import { AdminEditor } from './admin-tools/admin-editor';
const admin = {
    AdminEditor: AdminEditor,
};
export default admin;
